import { render, staticRenderFns } from "./ProductionForeman.vue?vue&type=template&id=b16163c4&scoped=true"
import script from "./ProductionForeman.vue?vue&type=script&lang=js"
export * from "./ProductionForeman.vue?vue&type=script&lang=js"
import style0 from "./ProductionForeman.vue?vue&type=style&index=0&id=b16163c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16163c4",
  null
  
)

export default component.exports